var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carryOnCode"},[_vm._m(0),_c('div',{staticClass:"btn",on:{"click":_vm.goBack}},[_vm._v("返回首页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{attrs:{"id":"qrcodea"}})])
}]

export { render, staticRenderFns }